export { default as WishlistContainer } from './components/WishlistOverviewContainer.js';
//# sourceMappingURL=overview.js.map
